module.exports = __webpack_public_path__ + "static/img/sou-w@2x.23dd8af8.png";